import { ThunkDispatch } from "@reduxjs/toolkit";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { PanoramaBeforeImageState } from "../../reducers/panorama";

import PanoramaEditFormEmpty from "./PanoramaEditFormEmpty";
import PanoramaEditFormSome from "./PanoramaEditFormSome";
import PanoramaModals from "./PanoramaModals";

// State型定義
interface RootState {
  panorama: {
    beforeImages: PanoramaBeforeImageState[];
    [key: string]: any;
  };
  [key: string]: any;
}

// mapStateToPropsの型定義
function mapStateToProps(state: RootState) {
  return { ...state.panorama };
}

// コンポーネントのProps型定義
interface PanoramaFormProps {
  beforeImages: PanoramaBeforeImageState[];
}

const PanoramaForm = (props: PanoramaFormProps) => {
  const { beforeImages } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();

  return (
    <>
      {beforeImages.length === 0 && <PanoramaEditFormEmpty />}
      {beforeImages.length > 0 && <PanoramaEditFormSome />}
      <PanoramaModals />
    </>
  );
};

export default connect(mapStateToProps)(PanoramaForm);
